import styled from '@emotion/styled'

export const TextLabel = styled.p`
  padding-bottom: 20px;
  text-align: center;
`